import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "sentiment_satisfied",
    title: "Stress-Free Move",
    description: "Focus on your move while we handle the cleaning.",
  },
  {
    icon: "credit_card_heart",
    title: "Deposit Recovery",
    description: "Ensure the property meets landlord or agent standards.",
  },
  {
    icon: "groups",
    title: "Expert Team",
    description: "Skilled cleaners equipped with the tools and knowledge for thorough results.",
  },
  {
    icon: "tune",
    title: "Tailored Service",
    description: "Tailored to meet your specific needs and property requirements.",
  },
];

function EndOfTenancy_Section1() {
  return (
    <ServiceHighlights
      title="Why Choose Our End of Tenancy Cleaning?"
      description="Moving out can be stressful, and ensuring the property is spotless for inspections or new tenants is essential. Our End of Tenancy Cleaning Services provide a comprehensive and hassle-free solution, leaving the space immaculate and ready for its next chapter."
      items={items}
    />
  );
}

export default EndOfTenancy_Section1;
